<template>
  <table class="responsive-table">
    <thead>
      <tr>
        <th
          v-for="col in columns"
          :key="col"
        >
          {{ col }}
        </th>
        <th />
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="row in payments"
        :key="row.id"
      >
        <td>
          {{ row.description }}
          <label
            class="d-block d-md-none"
          >
            {{ columns[0] }}
          </label>
        </td>

        <td v-if="row.credit_used">
          1 Credit
          <label
            class="d-block d-md-none"
          >
            {{ columns[1] }}
          </label>
        </td>
        <td v-else>
          {{ row.amount_due_cents / 100 | currency }}
          <label
            class="d-block d-md-none"
          >
            {{ columns[1] }}
          </label>
        </td>

        <td>
          {{ row.due_date | dateOnly }}
          <label
            class="d-block d-md-none"
          >
            {{ columns[2] }}
          </label>
        </td>

        <td>
          {{ row.statusStr}}
          <label
            class="d-block d-md-none"
          >
            {{ columns[3] }}
          </label>
        </td>

        <td class="actions">
          <p v-if="row.paid_on_date">
            Paid on {{ row.paid_on_date | dateOnly }}
          </p>

          <button class="btn btn-ghost" type="button" @click="payNow(row)" v-else>
            Pay
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'ResponsiveTable',
  data: () => ({
    columns: ['Description', 'Amount', 'Due Date', 'Status'],
  }),
  props: {
    payments: {
      type: Array,
    },
    payNow: {
      type: Function,
    },
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.responsive-table {
  @include border-radius($border-radius);

  width: 100%;
  border: none;

  thead {
    background: none;
    color: white;

    th {
      position: relative;
      padding: 0.75rem;
      padding-right: $gutter;
      white-space: nowrap;
      border-bottom: 2px solid rgba(255, 255, 255, 0.25);
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;

      i,
      svg {
        position: absolute;
        top: 17px;
        right: 10px;
      }

      .fa-sort {
        z-index: 1;
        opacity: 0.2;
      }

      span {
        .fa-sort-up {
          z-index: 2;
          opacity: 0;
        }

        .fa-sort-down {
          z-index: 3;
          opacity: 0;
        }

        &.active-down {
          .fa-sort-down {
            opacity: 1;
          }
        }

        &.active-up {
          .fa-sort-up {
            opacity: 1;
          }
        }
      }

      &:hover {
        .fa-sort {
          opacity: 0.3;
        }

        span {
          .fa-sort-down {
            opacity: 1;
          }

          &.active-down {
            .fa-sort-down {
              opacity: 1;
            }

            .fa-sort-up {
              opacity: 0;
            }
          }

          &.active-up {
            .fa-sort-up {
              opacity: 1;
            }

            .fa-sort-down {
              opacity: 0;
            }
          }
        }
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 0.75rem;
        color: rgba(white, 0.87);
        border-top: 1px solid rgba(255, 255, 255, 0.25);
        text-transform: capitalize;

        a {
          color: darken($highlight-color, 5%);
        }
      }
    }
  }

  .actions {
    text-align: right;
  }

  @media (max-width: $sm-max) {
    display: block;
    border: none;

    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    tbody {
      tr {
        background: $dark-blue;

        td {
          padding: 0.75rem;
          text-align: right;
          border-bottom: none;
          border-top: 1px solid rgba(255, 255, 255, 0.25);

          &:last-of-type {
            border-bottom: none;
          }
        }
      }
    }

    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      @include border-radius($border-radius);

      margin: 0 0 1rem 0;
      background: white;
    }

    td {
      position: relative;
      padding-left: 50%;
      border: none;
      border-bottom: $secondary-border;

      label {
        position: absolute;
        top: 12.5px;
        left: 15px;
        width: 45%;
        padding-right: 10px;
        font-weight: bold;
        white-space: nowrap;
        text-align: left;
      }
    }

    .btn-ghost {
      border-color: $primary-color;
      background: $primary-color;
      color: $btn-color;
      height: 45px;

      &:hover,
      &:focus {
        border-color: darken($primary-color, 5%);
        background-color: darken($primary-color, 5%);
        color: $btn-color;
      }
    }
  }
}
</style>
